export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-3">
              移动观影
            </h2>
            <p className="text-sm md:text-base text-foreground-300 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
              星空电影网完美适配手机与平板浏览器。无论是在通勤路上、午休间隙还是睡前放松，
              打开手机浏览器即可享受和桌面端一样的不缓冲秒开体验。智能画质调节功能
              自动适配移动网络环境，用更少的流量获得最佳的观影效果。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4">
              <div className="flex items-center gap-2 text-foreground-400">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-android-line text-secondary-400"></i>
                </span>
                <span className="text-sm">Android 浏览器访问</span>
              </div>
              <div className="flex items-center gap-2 text-foreground-400">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-apple-line text-secondary-400"></i>
                </span>
                <span className="text-sm">iOS Safari 访问</span>
              </div>
              <div className="flex items-center gap-2 text-foreground-400">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-tablet-line text-secondary-400"></i>
                </span>
                <span className="text-sm">平板全适配</span>
              </div>
            </div>
          </div>

          <div className="flex-1 flex justify-center lg:justify-end">
            <div className="relative w-64 md:w-72 aspect-[9/16] rounded-2xl overflow-hidden border-2 border-background-300/40">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20screen%20displaying%20cinematic%20movie%20streaming%20interface%20with%20dark%20theme%20and%20golden%20accents%2C%20film%20poster%20thumbnails%2C%20clean%20modern%20UI%2C%20movie%20app%20design%2C%20warm%20lighting%20effect%2C%20premium%20aesthetic&width=500&height=900&seq=app-mobile-01&orientation=portrait"
                alt="星空电影网移动观影界面展示"
                className="w-full h-full object-cover object-top"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  if (target.parentElement) {
                    target.parentElement.style.display = 'none';
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}